import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "title"]

  connect() {
    this._onOpen = (e) => this.open(e.detail)
    document.addEventListener("reports-panel:open", this._onOpen)

    this._onKeydown = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKeydown)

    this._onResize = () => this._applyLayout()
    window.addEventListener("resize", this._onResize)

    this._onBeforeCache = () => this._resetForCache()
    document.addEventListener("turbo:before-cache", this._onBeforeCache)

    this._openFromQueryParams()
  }

  disconnect() {
    document.removeEventListener("reports-panel:open", this._onOpen)
    document.removeEventListener("keydown", this._onKeydown)
    window.removeEventListener("resize", this._onResize)
    document.removeEventListener("turbo:before-cache", this._onBeforeCache)
  }

  open({ url, title } = {}) {
    if (url) {
      const frame = document.getElementById("reports_panel_content")
      if (frame) frame.src = url
    }

    if (title && this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }

    this.overlayTarget.style.display = "block"
    requestAnimationFrame(() => {
      this.overlayTarget.style.opacity = "1"
      this.panelTarget.style.translate = "0 0"
    })

    document.body.style.overflow = "hidden"
  }

  close() {
    const isMobile = this._isMobile()

    this.overlayTarget.style.opacity = "0"
    this.panelTarget.style.translate = isMobile ? "0 100%" : "100% 0"

    const onEnd = () => {
      this.overlayTarget.style.display = "none"
      document.body.style.overflow = ""
      this.panelTarget.removeEventListener("transitionend", onEnd)
    }
    this.panelTarget.addEventListener("transitionend", onEnd)
  }

  overlayTargetConnected(el) {
    el.addEventListener("click", () => this.close())
  }

  _resetForCache() {
    const isMobile = this._isMobile()
    this.panelTarget.style.translate = isMobile ? "0 100%" : "100% 0"
    this.overlayTarget.style.display = "none"
    this.overlayTarget.style.opacity = "0"
    document.body.style.overflow = ""
  }

  _isMobile() {
    return window.innerWidth < 768
  }

  /** Quand le panneau est fermé et que la fenêtre change de breakpoint, réaligner le transform (inline) sur le mode mobile / desktop. */
  _syncClosedTransformIfNeeded() {
    const overlay = this.overlayTarget
    const panel = this.panelTarget
    if (window.getComputedStyle(overlay).display === "none") {
      const mobile = this._isMobile()
      panel.style.translate = mobile ? "0 100%" : "100% 0"
    }
  }

  _applyLayout() {
    this._syncClosedTransformIfNeeded()
  }

  _openFromQueryParams() {
    const params = new URLSearchParams(window.location.search)
    const campaignId = params.get("open_campaign_id")
    if (!campaignId) return

    const appProjectId = this._appProjectIdFromPathOrQuery(params)
    if (!appProjectId) return

    const url = `/app_projects/${encodeURIComponent(appProjectId)}/test_campaigns/${encodeURIComponent(campaignId)}/reports`
    this.open({ url })

    params.delete("open_campaign_id")
    const nextQuery = params.toString()
    const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ""}${window.location.hash}`
    window.history.replaceState({}, "", nextUrl)
  }

  _appProjectIdFromPathOrQuery(params) {
    const fromQuery = params.get("app_project_id")
    if (fromQuery) return fromQuery

    const match = window.location.pathname.match(/\/app_projects\/(\d+)/)
    return match ? match[1] : null
  }
}
